var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigifinex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.1896 47.6605C73.6801 66.133 63.2078 75.3711 45.7725 75.3711H34.7207L32.3906 75.2376L35.5473 62.4994H45.0444C54.4917 62.4994 60.2124 57.0616 62.2091 46.1854C62.3512 45.4871 62.4667 44.7837 62.5553 44.0766L77.7101 35.2225C77.9012 36.6174 78 38.0847 78 39.6265C78 41.9215 77.7298 44.6005 77.1894 47.6605H77.1896ZM72.4509 23.599L58.8607 31.5427C56.9666 30.2647 54.3828 29.6243 51.1142 29.6243H29.1841L29.2499 29.304L31.8432 17H54.5973C57.7772 17 60.6472 17.3669 63.2173 18.104C66.6315 19.0852 69.5053 20.7096 71.8476 22.9816C72.053 23.1832 72.2541 23.389 72.4509 23.599Z",
    fill: "#6E45B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7814 40.5804L48.768 53.3115H39.3534L34.7501 75.238L34.7203 75.371H14L21.7797 64.7452L26.8843 40.5804H50.7814Z",
    fill: "#00D8CD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigifinex);
export default __webpack_public_path__ + "static/media/Digifinex.7c7989fae15da842ff4bd5e803d75f68.svg";
export { ForwardRef as ReactComponent };